import { render, staticRenderFns } from "./vip10-1.vue?vue&type=template&id=93ab4b12&scoped=true&"
import script from "./vip10-1.vue?vue&type=script&lang=ts&"
export * from "./vip10-1.vue?vue&type=script&lang=ts&"
import style0 from "./vip10-1.vue?vue&type=style&index=0&id=93ab4b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ab4b12",
  null
  
)

export default component.exports